// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recharts-scatter .recharts-scatter-symbol .recharts-symbols {\n    transition: .2s ease fill;\n    stroke: #adadad;\n    stroke-width: initial;\n}\n.recharts-scatter .recharts-scatter-symbol:hover .recharts-symbols {\n    fill:rgb(255, 131, 51);    \n}", ""]);
// Exports
module.exports = exports;
